import api from "../../instance/api";
import {
  errorCreateAttributes,
  errorGetAttributes,
  errorUpdateAttributes,
  errorDeleteAttributes,
  startCreateAttributes,
  startGetAttributes,
  startUpdateAttributes,
  startDeleteAttributes,
  successCreateAttributes,
  successGetAttributes,
  successUpdateAttributes,
  successDeleteAttributes,
} from "../../slice/Attributes";

const getAttributesApi = () => async (dispatch) => {
  dispatch(startGetAttributes());
  let id = localStorage.getItem("organisationId");
  try {
    const res = await api.get(
      `organisation-attribute/attributesByOrganization/${id}`
    );

    dispatch(successGetAttributes(res?.data));
    console.log("res======>", res);
  } catch (err) {
    dispatch(errorGetAttributes(err?.response?.data?.message));
    console.log("Download error:", err);
  }
};

const createAttributesApi = (payload) => async (dispatch) => {
  dispatch(startCreateAttributes());
  try {
    const res = await api.post(
      `organisation-attribute/createBulkAttributes`,
      payload
    );

    dispatch(successCreateAttributes(res?.data));
    console.log("res======>", res);
  } catch (err) {
    dispatch(errorCreateAttributes(err?.response?.data?.message));
    console.log("Download error:", err);
  }
};

const updateAttributesApi = (payload) => async (dispatch) => {
  dispatch(startUpdateAttributes());
  try {
    const res = await api.post(
      `organisation-attribute/createBulkAttributes`,
      payload
    );

    dispatch(successUpdateAttributes(res?.data));
    console.log("res======>", res);
  } catch (err) {
    dispatch(errorUpdateAttributes(err?.response?.data?.message));
    console.log("Download error:", err);
  }
};

const deleteAttributesApi = (id) => async (dispatch) => {
  dispatch(startDeleteAttributes());
  try {
    const res = await api.delete(
      `organisation-attribute/${id}`
    );

    // Check if response indicates failure
    if (res?.data?.status === false || res?.data?.response_code === 1) {
      const errorMessage =
        res?.data?.errorResponse?.errorMessage ||
        res?.data?.payload ||
        "Failed to delete";
      dispatch(errorDeleteAttributes(errorMessage));
      return;
    }

    // For 204 No Content or success, send a success flag
    dispatch(successDeleteAttributes({ success: true, id }));
    console.log("Delete res======>", res);
  } catch (err) {
    const errorMessage =
      err?.response?.data?.errorResponse?.errorMessage ||
      err?.response?.data?.payload ||
      err?.response?.data?.message ||
      "Failed to delete";
    dispatch(errorDeleteAttributes(errorMessage));
    console.log("Delete error:", err);
  }
};

export { getAttributesApi, createAttributesApi, updateAttributesApi, deleteAttributesApi };
